import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isSupportedSchemaFieldType } from './is-supported-schema-field-type.js'
import { unsupportedSchemaFieldTypeMessage } from './unsupported-schema-field-type-message.js'

export function assertSupportedSchemaFieldType(field: SchemaField): void {
  if (isSupportedSchemaFieldType(field)) return
  throw new Error(unsupportedSchemaFieldTypeMessage(field))
}
